import React from 'react';

export const SuccessCheckmark: React.FC<React.SVGProps<SVGSVGElement>> = (
  props
) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <mask
      id="mask0_131_4623"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="16"
      height="16"
    >
      <rect width="16" height="16" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_131_4623)">
      <path
        d="M7.06634 11.0663L11.7663 6.36634L10.833 5.43301L7.06634 9.19967L5.16634 7.29967L4.23301 8.23301L7.06634 11.0663ZM7.99967 14.6663C7.07745 14.6663 6.21079 14.4913 5.39967 14.1413C4.58856 13.7913 3.88301 13.3163 3.28301 12.7163C2.68301 12.1163 2.20801 11.4108 1.85801 10.5997C1.50801 9.78856 1.33301 8.9219 1.33301 7.99967C1.33301 7.07745 1.50801 6.21079 1.85801 5.39967C2.20801 4.58856 2.68301 3.88301 3.28301 3.28301C3.88301 2.68301 4.58856 2.20801 5.39967 1.85801C6.21079 1.50801 7.07745 1.33301 7.99967 1.33301C8.9219 1.33301 9.78856 1.50801 10.5997 1.85801C11.4108 2.20801 12.1163 2.68301 12.7163 3.28301C13.3163 3.88301 13.7913 4.58856 14.1413 5.39967C14.4913 6.21079 14.6663 7.07745 14.6663 7.99967C14.6663 8.9219 14.4913 9.78856 14.1413 10.5997C13.7913 11.4108 13.3163 12.1163 12.7163 12.7163C12.1163 13.3163 11.4108 13.7913 10.5997 14.1413C9.78856 14.4913 8.9219 14.6663 7.99967 14.6663ZM7.99967 13.333C9.48856 13.333 10.7497 12.8163 11.783 11.783C12.8163 10.7497 13.333 9.48856 13.333 7.99967C13.333 6.51079 12.8163 5.24967 11.783 4.21634C10.7497 3.18301 9.48856 2.66634 7.99967 2.66634C6.51079 2.66634 5.24967 3.18301 4.21634 4.21634C3.18301 5.24967 2.66634 6.51079 2.66634 7.99967C2.66634 9.48856 3.18301 10.7497 4.21634 11.783C5.24967 12.8163 6.51079 13.333 7.99967 13.333Z"
        fill="#1E853B"
      />
    </g>
  </svg>
);
